/* =============================================
   TSC Product Detail Page — JavaScript
   ============================================= */

(function () {
  'use strict';

  /* ── GALLERY ─────────────────────────────── */
  function initGallery() {
    var gallery = document.querySelector('.tsc-gal');
    if (!gallery) return;

    var thumbs = gallery.querySelectorAll('.tsc-thumb');
    var slides = gallery.querySelectorAll('.tsc-main-image__slide');
    var counter = gallery.querySelector('.tsc-main-image__counter');
    var dots = gallery.querySelectorAll('.tsc-gal__dot');
    var mainImage = gallery.querySelector('.tsc-main-image');
    var current = 0;
    var isMobile = window.matchMedia('(max-width: 979px)');

    /* ── Desktop: click-to-show (unchanged) ── */
    function goToDesktop(index) {
      if (index < 0 || index >= slides.length) return;
      current = index;
      slides.forEach(function (s, i) {
        s.classList.toggle('tsc-main-image__slide--active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('tsc-thumb--active', i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('tsc-gal__dot--active', i === index);
      });
      if (counter) {
        counter.textContent = (index + 1) + ' / ' + slides.length;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goToDesktop(i); });
    });

    /* ── Mobile: size the carousel to match the ACTIVE slide ──
       Without this, the flex row holding all slides stretches the
       whole container to the height of the tallest image among
       the full set, leaving dead space under any shorter slide. ── */
    function getSlideAspectRatio(slide) {
      if (!slide) return null;
      var img = slide.querySelector('img');
      if (!img) return null;
      var w = img.naturalWidth || parseFloat(img.getAttribute('width'));
      var h = img.naturalHeight || parseFloat(img.getAttribute('height'));
      if (!w || !h) return null;
      return h / w;
    }

    function applyMobileHeight() {
      if (!mainImage || !isMobile.matches) return;
      var slide = slides[current];
      var ratio = getSlideAspectRatio(slide);
      if (!ratio) return;
      var width = mainImage.offsetWidth;
      if (!width) return;
      mainImage.style.height = Math.round(width * ratio) + 'px';
    }

    function clearMobileHeight() {
      if (mainImage) mainImage.style.height = '';
    }

    /* ── Mobile: sync dots/counter with scroll position ── */
    function updateFromScroll() {
      if (!mainImage || !isMobile.matches) return;
      var scrollLeft = mainImage.scrollLeft;
      var width = mainImage.offsetWidth;
      if (width === 0) return;
      var index = Math.round(scrollLeft / width);
      if (index === current) return;
      current = index;

      dots.forEach(function (d, i) {
        d.classList.toggle('tsc-gal__dot--active', i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('tsc-thumb--active', i === index);
      });
      if (counter) {
        counter.textContent = (index + 1) + ' / ' + slides.length;
      }
      applyMobileHeight();
    }

    if (mainImage) {
      var scrollTimer;
      mainImage.addEventListener('scroll', function () {
        cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(updateFromScroll);
      }, { passive: true });
    }

    /* Dot clicks scroll to the right slide on mobile */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (isMobile.matches && mainImage) {
          mainImage.scrollTo({ left: mainImage.offsetWidth * i, behavior: 'smooth' });
        } else {
          goToDesktop(i);
        }
      });
    });

    /* Recalculate on resize/orientation change and on the
       mobile/desktop breakpoint switching */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyMobileHeight, 100);
    });

    if (typeof isMobile.addEventListener === 'function') {
      isMobile.addEventListener('change', function (e) {
        if (e.matches) {
          applyMobileHeight();
        } else {
          clearMobileHeight();
        }
      });
    }

    goToDesktop(0);
    applyMobileHeight();
  }

  /* ── FORMAT / VARIANT SELECTOR ───────────── */
  function initFormatSelector() {
    var container = document.querySelector('[data-tsc-product-form]');
    if (!container) return;

    var buttons = container.querySelectorAll('.tsc-fo');
    var variantInput = container.querySelector('[name="id"]');
    var atcButton = container.querySelector('.tsc-atc');
    var stickyPrice = document.querySelector('.tsc-sticky__price');
    var atcLabel = atcButton ? (atcButton.getAttribute('data-tsc-atc-label') || atcButton.textContent.split('\u00B7')[0].trim()) : '';

    if (atcButton) atcButton.setAttribute('data-tsc-atc-label', atcLabel);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isUnavailable = btn.classList.contains('tsc-fo--unavailable');

        buttons.forEach(function (b) { b.classList.remove('tsc-fo--selected'); });
        btn.classList.add('tsc-fo--selected');

        var variantId = btn.getAttribute('data-variant-id');
        var variantPrice = btn.getAttribute('data-variant-price');

        if (variantInput) variantInput.value = variantId;

        if (atcButton) {
          if (isUnavailable) {
            atcButton.disabled = true;
            atcButton.textContent = 'Sold out';
          } else {
            atcButton.disabled = false;
            atcButton.textContent = atcLabel + ' \u00B7 ' + variantPrice;
          }
        }

        /* Update Klarna placement */
        var klarna = container.querySelector('klarna-placement');
        if (klarna && variantPrice) {
          klarna.setAttribute('data-purchase-amount', variantPrice.replace(/[^0-9]/g, ''));
        }

        /* Update sticky bar price */
        if (stickyPrice && variantPrice) {
          stickyPrice.textContent = isUnavailable ? 'Sold out' : variantPrice;
        }
      });
    });
  }

  /* ── STICKY BAR ──────────────────────────── */
  function initStickyBar() {
    var sticky = document.querySelector('.tsc-sticky');
    var atc = document.querySelector('.tsc-atc');
    if (!sticky || !atc) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('tsc-sticky--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(atc);

    var stickyBtn = sticky.querySelector('.tsc-sticky__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-tsc-product-form]');
        if (form) form.submit();
      });
    }
  }

  /* ── ACCORDION ────────────────────────────── */
  function initAccordion() {
    var triggers = document.querySelectorAll('.tsc-accordion__trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.tsc-accordion__item');
        var isOpen = item.classList.contains('tsc-accordion__item--open');

        /* Close all panels */
        var parent = item.parentElement;
        parent.querySelectorAll('.tsc-accordion__item--open').forEach(function (openItem) {
          openItem.classList.remove('tsc-accordion__item--open');
          var t = openItem.querySelector('.tsc-accordion__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        /* Open clicked panel if it was closed */
        if (!isOpen) {
          item.classList.add('tsc-accordion__item--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── REVIEW TABS ─────────────────────────── */
  function initReviewTabs() {
    var tabContainer = document.querySelector('.tsc-tabs');
    if (!tabContainer) return;

    var tabs = tabContainer.querySelectorAll('.tsc-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('tsc-tab--active'); });
        tab.classList.add('tsc-tab--active');
      });
    });
  }

  /* ── YOTPO REINIT ────────────────────────── */
  function initYotpo() {
    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
      return;
    }
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
        window.yotpo.refreshWidgets();
        clearInterval(interval);
      } else if (attempts > 30) {
        clearInterval(interval);
      }
    }, 200);
  }

  /* ── INIT ─────────────────────────────────── */
  function init() {
    initGallery();
    initFormatSelector();
    initStickyBar();
    initReviewTabs();
    initAccordion();
    initYotpo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();